module.exports = __webpack_public_path__ + "img/qwen-image-2-0-pro.24a6128b.jpg";